// extracted by mini-css-extract-plugin
module.exports = {"ImageGalleryItem":"ImageGalleryItem_ImageGalleryItem__2VfMK","ImageGalleryItem_image":"ImageGalleryItem_ImageGalleryItem_image__2DEh0"};